import R from 'ramda';
import actionTypes from '../actionTypes';

const initialState = {
  dealBlocks: [],
};

export default (state = initialState, action) => {
  let index, dealBlocks;

  switch (action.type) {
    case actionTypes.DEAL_BLOCK_RESET_CHANGES:
      return { ...state, dealBlocks: [] };

    case actionTypes.DEAL_BLOCK_REMOVE_CHANGES:
      dealBlocks = state.dealBlocks;
      index = R.findIndex(R.propEq('id', action.payload.id))(dealBlocks);

      if (index !== -1) {
        dealBlocks[index] = {
          id: action.payload.id,
          accept: true,
          accept2: true,
        };
      } else {
        dealBlocks.push({
          id: action.payload.id,
          accept: true,
          accept2: true,
        });
      }

      return { ...state, dealBlocks: dealBlocks.concat() };

    case actionTypes.DEAL_BLOCK_SET_CHANGES:
      const { id, options, content, checked, accept, accept2 } = action.payload;

      dealBlocks = state.dealBlocks;
      index = R.findIndex(R.propEq('id', id))(dealBlocks);

      if (index !== -1) {
        dealBlocks[index].changes = options;
        dealBlocks[index].content = content;
        dealBlocks[index].checked = checked;
        dealBlocks[index].accept = accept;
        dealBlocks[index].accept2 = accept2;
      } else {
        dealBlocks.push({
          id,
          changes: options,
          content,
          checked,
          accept,
          accept2,
        });
      }

      return { ...state, dealBlocks: dealBlocks.concat() };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/redux/reducers/dealBlocks.js